import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'assetUrl'})
export class AssetUrlPipe implements PipeTransform {
  transform(value: string, fullUrl = false): string {
    return (fullUrl ? (`${window.location.protocol}//${window.location.host}/`) : '') + `api/file/${value}`;
  }
}
